export interface PendingChanges {
    added: Set<string>;
    removed: Set<string>;
}

export const getUpdatedExpandedComps = (
    allComps: any[],
    pendingChanges: {
        added: Set<string>;
        removed: Set<string>;
    }
) => {
    return allComps.map(comp => ({
        ...comp,
        uiEnabled:
            pendingChanges.added.has(comp.recordId) ||
            (comp.uiEnabled && !pendingChanges.removed.has(comp.recordId)),
        enable:
            pendingChanges.added.has(comp.recordId) ||
            (comp.enable && !pendingChanges.removed.has(comp.recordId)),
    }));
};
